module.exports = __webpack_public_path__ + "img/update-icon.ff402e62.svg";